<form [formGroup]="parcelForm">
  <div class="row">
    <div class="col-md-6">
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Length</mat-label>
          <input required type="number" formControlName="length" matInput placeholder="Length" />
          <mat-hint>cm</mat-hint>
          @if (parcelForm.get('length')?.invalid) {
            <mat-error>
              Invalid length
            </mat-error>
          }
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Height</mat-label>
          <input required type="number" min="1" formControlName="height" matInput placeholder="Height" />
          <mat-hint>cm</mat-hint>
          @if (parcelForm.get('height')?.invalid) {
            <mat-error>
              Invalid height
            </mat-error>
          }
        </mat-form-field>

      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Width</mat-label>
          <input required type="number" min="1" formControlName="width" matInput placeholder="Width" />
          <mat-hint>cm</mat-hint>
          @if (parcelForm.get('width')?.invalid) {
            <mat-error>
              Invalid width
            </mat-error>
          }
        </mat-form-field>
      </p>
    </div>
    <div class="col-md-6">
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Mass</mat-label>
          <input required type="number" min="0.01" max="25" formControlName="mass" matInput placeholder="Mass" />
          <mat-hint>kg</mat-hint>
          @if (parcelForm.get('mass')?.invalid) {
            <mat-error>
              Invalid mass - minimum is 0.01kg (100g) and max is 25kg
            </mat-error>
          }
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Parcel count</mat-label>
          <input required type="number" min="1" formControlName="parcelCount" matInput placeholder="Parcel count" />
          @if (parcelForm.get('parcelCount')?.invalid) {
            <mat-error>
              Invalid count
            </mat-error>
          }
        </mat-form-field>
      </p>
    </div>
    <div class="col-md-12">
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Parcel description</mat-label>
          <textarea formControlName="parcelDescription" matInput placeholder="Parcel description"></textarea>
          @if (parcelForm.get('parcelDescription')?.invalid) {
            <mat-error>
              Invalid parcel description
            </mat-error>
          }
        </mat-form-field>
      </p>
    </div>
  </div>
</form>

<div class="py-2">
  <button [disabled]="!parcelForm.valid" (click)="addParcel()" mat-stroked-button>
    <mat-icon>add</mat-icon> Add
  </button>
</div>